import Style from "../components/Style.module.css"
import React, {useState} from "react";
import {Accordion, AccordionBody, AccordionHeader} from "react-bootstrap";
import CloseIcon from '@mui/icons-material/Close';

function PageTips({headerText, children}) {
    const [messageOpen, setMessageOpen] = useState(true)

    function openMessage() {
        setMessageOpen(true)
    }

    function closeMessage(event) {
        setMessageOpen(false)
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
    }

    return (
        <div className={Style.pageTips}>
            <div className={messageOpen ? `${Style.pageTipsHeader} ${Style.h5Heading}` : `${Style.pageTipsHeaderOnly} ${Style.h5Heading}`} onClick={openMessage}>
                <div>{headerText}</div>
                <CloseIcon style={ {width: "24px", height: "24px", alignSelf: "right"} } onClick={closeMessage}></CloseIcon>
            </div>
            {messageOpen &&
                <div className={Style.pageTipsBody}>
                    {children}
                </div>}
        </div>

    )
}

export default PageTips